var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceFlowMeter01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M289.5,150.1l26-58.5C210.1,73,97.5,104.2,16,185.6l43.6,43.6C122.4,166.5,207.7,140.3,289.5,150.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.9,210c-57.6-1.7-115.6,19-159.6,62.8l43.6,43.6c24.8-24.8,55.7-39.2,87.9-43.5L262.9,210z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.1,98.3c-3.8,0-7,2.1-8.9,5l-1.4,3.2L217.6,360.8c-3.5,6.2-5.6,13.3-5.6,21.1c0,24.1,19.6,43.7,43.7,43.7 c21.1,0,38.5-14.8,42.8-34.6l0.1-0.8l53.3-281C352,103.2,347.1,98.3,341.1,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.5,295.3c9.5,6,18.4,13,26.6,21.2l43.6-43.6c-17.5-17.5-37.2-31-58.1-41.2L338.5,295.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.1,107.7l-11.7,61.4c32.6,13.5,63.3,33.5,89.9,60.1l43.6-43.6C460.3,149.9,418.5,124.2,374.1,107.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceFlowMeter01);
export default __webpack_public_path__ + "static/media/deviceFlowMeter-01.37b1bdbf33511109ad4d22b22fa149dd.svg";
export { ForwardRef as ReactComponent };